import { TConnection } from '../../../../../../../api/blueprints/connection.template.types';
import { BaseConnectionFormVM } from '../base-connection-form.viewmodel';
import { configList } from './connection-other-form.config';

export class ConnectionOtherFormVM extends BaseConnectionFormVM {
    constructor(
        connection: TConnection,
        readonly addConnection: (connection: TConnection) => void,
        readonly editConnection: (connection: TConnection) => void,
    ) {
        super(connection, configList, addConnection, editConnection);
    }
}
